import { render, staticRenderFns } from "./Fuel.vue?vue&type=template&id=07c2a6be"
var script = {}
import style0 from "./Fuel.vue?vue&type=style&index=0&id=07c2a6be&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports